import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from '@material-ui/core';
import { useSnackbar } from 'react-simple-snackbar';
import { useDispatch } from 'react-redux';
import { changeUserPassword } from '../../actions/auth';

const ChangePassword = ({ 
  open, 
  onClose, 
  user, 
  title = "Change Password" 
}) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  
  const dispatch = useDispatch();
  const [openSnackbar] = useSnackbar({
    position: 'bottom-right',
    style: {
      backgroundColor: "#333",
      color: "#fff",
      fontSize: "16px",
      textAlign: "center",
    }
  });

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!newPassword.trim()) {
      newErrors.newPassword = "New password is required";
      isValid = false;
    } else if (newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters";
      isValid = false;
    }

    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Please confirm the password";
      isValid = false;
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handlePasswordChange = async () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      await dispatch(changeUserPassword(user._id, newPassword, openSnackbar));
      handleClose();
    } catch (error) {
      console.error("Error changing password:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
    setLoading(false);
    onClose();
  };

  const handleFieldChange = (field, value) => {
    if (field === 'newPassword') {
      setNewPassword(value);
    } else if (field === 'confirmPassword') {
      setConfirmPassword(value);
    }
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: "" }));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
        }
      }}
    >
      <DialogTitle
        style={{
          backgroundColor: '#ef7f1a',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '1.2rem',
          padding: '16px 24px'
        }}
      >
        {title} {user?.name && `for ${user.name}`}
      </DialogTitle>
      
      <DialogContent style={{ padding: '24px' }}>
        <Box display="flex" flexDirection="column">
          <TextField
            fullWidth
            label="New Password"
            type="password"
            value={newPassword}
            onChange={(e) => handleFieldChange('newPassword', e.target.value)}
            error={!!errors.newPassword}
            helperText={errors.newPassword}
            variant="outlined"
            required
            disabled={loading}
            style={{ marginBottom: '20px' }}
          />
          <TextField
            fullWidth
            label="Confirm Password"
            type="password"
            value={confirmPassword}
            onChange={(e) => handleFieldChange('confirmPassword', e.target.value)}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword}
            variant="outlined"
            required
            disabled={loading}
          />
        </Box>
      </DialogContent>
      
      <DialogActions style={{ padding: '16px 24px', backgroundColor: '#fafafa' }}>
        <Button
          onClick={handleClose}
          disabled={loading}
          style={{
            color: '#666',
            fontWeight: '500',
            textTransform: 'none'
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handlePasswordChange}
          disabled={loading}
          style={{
            backgroundColor: loading ? '#ccc' : '#ef7f1a',
            color: 'white',
            fontWeight: '600',
            padding: '8px 24px',
            borderRadius: '6px',
            textTransform: 'none',
            minWidth: '120px'
          }}
        >
          {loading ? 'Changing...' : 'Change Password'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePassword;
